'use client'

import { useState } from 'react'
import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'
import { CheckIcon } from '@heroicons/react/20/solid'
import { dataFocusOutline, focusOutline, textColor } from '../../Resources/CSS/styling'
import { useTranslation } from '../../Translation'

const people = [
  { id: 1, name: 'Wade Cooper' },
  { id: 2, name: 'Arlene Mccoy' },
  { id: 3, name: 'Devon Webb' },
  { id: 4, name: 'Tom Cook' },
  { id: 5, name: 'Tanya Fox' },
  { id: 6, name: 'Hellen Schmidt' },
  { id: 7, name: 'Caroline Schultz' },
  { id: 8, name: 'Mason Heaney' },
  { id: 9, name: 'Claudie Smitham' },
  { id: 10, name: 'Emil Schaefer' },
]

export default function Select({ title, options, selected, setSelected, minWidth }) {
    
  const { translate } = useTranslation();
  return (
    <Listbox value={selected} onChange={setSelected}>
      <Label className="block text-sm/6 font-medium text-gray-900">{title}</Label>
      <div className={`relative mt-2 ${minWidth ? minWidth : ''}`}>
        <ListboxButton className={`grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pl-3 pr-2 text-left text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 ${focusOutline} sm:text-sm/6`}>
          <span className="col-start-1 row-start-1 truncate pr-6">{selected ? (selected.label ? selected.label : translate(selected.name)) : ''}</span>
          <ChevronUpDownIcon
            aria-hidden="true"
            className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
          />
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {options.map((option) => (
            <ListboxOption
              key={option.id}
              value={option}
              className={`group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 ${dataFocusOutline} data-[focus]:text-white data-[focus]:outline-none`}
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{option.label || translate(option.name)}</span>

              <span className={`absolute inset-y-0 right-0 flex items-center pr-4 ${textColor} group-[&:not([data-selected])]:hidden group-data-[focus]:text-white`}>
                <CheckIcon aria-hidden="true" className="size-5" />
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  )
}
